import { FormLabels } from 'components/curo-components/forms/types';

export enum ContactInformationFields {
  BorrowerEmail = 'borrowerEmail',
  BorrowerPhone = 'borrowerPhone',
  TelephoneAndElectronicCommunicationPolicy = 'telephoneAndElectronicCommunicationPolicy',
}

export interface IContactInformationFormValues {
  [ContactInformationFields.BorrowerEmail]: string;
  [ContactInformationFields.BorrowerPhone]: string;
  [ContactInformationFields.TelephoneAndElectronicCommunicationPolicy]: boolean;
}

export const contactInformationFormLabels: FormLabels<ContactInformationFields> = {
  [ContactInformationFields.BorrowerEmail]: 'Email',
  [ContactInformationFields.BorrowerPhone]: 'Cell Phone',
  [ContactInformationFields.TelephoneAndElectronicCommunicationPolicy]:
    'I agree to Telephone and Electronic Communication Policy',
};
